import { ReactNode } from "react";

export { FullPageCenter };
type Props = {
  children: ReactNode;
};

const FullPageCenter = ({ children }: Props) => {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
      }}
    >
      <div style={{ flexGrow: 1 }}></div>
      {children}
      <div style={{ flexGrow: 1 }}></div>
    </div>
  );
};
